"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VariantCaller = VariantCaller;
exports.ScaffoldExample = ScaffoldExample;
exports.BAMViewer = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bam = require("@gmod/bam");

var _Alignment = _interopRequireDefault(require("../Alignment.js"));

var _ScaffoldViewer = _interopRequireDefault(require("../components/ScaffoldViewer.js"));

var _Components = require("./Components.js");

var _bam2 = _interopRequireDefault(require("../helpers/bam.js"));

var _colors = require("../helpers/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function VariantCaller(props) {
  return /*#__PURE__*/_react["default"].createElement("h1", null, "Variant calling example will go here.");
}

function ScaffoldExample() {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, "Scaffold viewer"), /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "The reference sequence stays fixed to the top."), /*#__PURE__*/_react["default"].createElement("li", null, "Click the scaffold to navigate to that portion of the alignment.")), /*#__PURE__*/_react["default"].createElement(_Components.DataFetcher, {
    child_prop: "fasta",
    source: "data/scaffold.fasta"
  }, /*#__PURE__*/_react["default"].createElement(_ScaffoldViewer["default"], null)));
}

var BAMViewer = /*#__PURE__*/function (_Component) {
  _inherits(BAMViewer, _Component);

  var _super = _createSuper(BAMViewer);

  function BAMViewer(props) {
    var _this;

    _classCallCheck(this, BAMViewer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "scrollExcavator", function () {
      return _this.scrollExcavator.broadcaster.location();
    });

    _defineProperty(_assertThisInitialized(_this), "onSequenceClick", function (label, i) {
      return function () {
        var _this$scrollExcavator = _this.scrollExcavator(),
            x_fraction = _this$scrollExcavator.x_fraction,
            y_fraction = _this$scrollExcavator.y_fraction,
            scroll_corrector = function scroll_corrector() {
          _this.scrollExcavator.broadcaster.broadcast(x_fraction, y_fraction, "main");
        };

        if (label == _this.state.label) {
          _this.setState({
            label: null,
            molecule: function molecule(mol) {
              return mol;
            },
            site_color: _colors.nucleotide_color
          }, scroll_corrector);
        } else {
          var desired_record = _this.state.fasta.filter(function (datum) {
            return datum.header == label;
          })[0],
              molecule = function molecule(mol, site, header) {
            if (mol == "-") return "-";
            if (header == desired_record.header) return mol;
            return mol == desired_record.seq[site - 1] ? "." : mol;
          };

          _this.setState({
            label: label,
            molecule: molecule,
            site_color: (0, _colors.nucleotide_difference)(desired_record)
          }, scroll_corrector);
        }
      };
    });

    _this.state = {
      window_start: 0,
      window_width: 200,
      site_size: 15,
      fasta: [],
      label: null,
      molecule: function molecule(mol) {
        return mol;
      },
      site_color: _colors.nucleotide_color
    };
    return _this;
  }

  _createClass(BAMViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var bam_file = new _bam.BamFile({
        bamUrl: this.props.data_url,
        baiUrl: this.props.data_url + ".bai"
      });
      this.bam = new _bam2["default"](bam_file);
      var _this$state = this.state,
          window_start = _this$state.window_start,
          window_width = _this$state.window_width;
      this.loadBamWindow(window_start, window_width);
    }
  }, {
    key: "loadBamWindow",
    value: function loadBamWindow(window_start, window_width) {
      var _this2 = this;

      var window_end = window_start + window_width;
      this.bam.fasta_window(window_start, window_end).then(function (fasta) {
        return _this2.setState({
          fasta: fasta,
          window_start: window_start,
          window_width: window_width
        });
      });
    }
  }, {
    key: "handleStartChange",
    value: function handleStartChange(e) {
      var window_start = +e.target.value,
          window_width = this.state.window_width;
      this.loadBamWindow(window_start, window_width);
    }
  }, {
    key: "handleWidthChange",
    value: function handleWidthChange(e) {
      var window_start = this.state.window_start,
          window_width = +e.target.value;
      this.loadBamWindow(window_start, window_width);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var width = 1140,
          toolbar_style = {
        display: "flex",
        justifyContent: "space-around",
        width: width
      };
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, "BAM viewer"), /*#__PURE__*/_react["default"].createElement("div", {
        style: toolbar_style
      }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("label", null, "Window start:"), /*#__PURE__*/_react["default"].createElement("input", {
        type: "number",
        value: this.state.window_start,
        min: 0,
        max: 100,
        step: 25,
        onChange: function onChange(e) {
          return _this3.handleStartChange(e);
        }
      })), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("label", null, "Window width:"), /*#__PURE__*/_react["default"].createElement("input", {
        type: "number",
        value: this.state.window_width,
        min: 100,
        max: 1000,
        step: 10,
        onChange: function onChange(e) {
          return _this3.handleWidthChange(e);
        }
      })), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("label", null, "Site size:"), /*#__PURE__*/_react["default"].createElement("input", {
        type: "number",
        value: this.state.site_size,
        min: 15,
        max: 100,
        step: 5,
        onChange: function onChange(e) {
          return _this3.setState({
            site_size: e.target.value
          });
        }
      })), /*#__PURE__*/_react["default"].createElement("span", null, "Number of reads in window: ", this.state.fasta.length)), /*#__PURE__*/_react["default"].createElement(_Alignment["default"], {
        width: width,
        height: 1000,
        site_size: this.state.site_size,
        fasta: this.state.fasta,
        start_site: this.state.window_start,
        molecule: this.state.molecule,
        site_color: this.state.site_color,
        onSequenceClick: this.onSequenceClick,
        excavator: this.scrollExcavator
      }));
    }
  }]);

  return BAMViewer;
}(_react.Component);

exports.BAMViewer = BAMViewer;
BAMViewer.defaultProps = {
  data_url: "data/sorted.bam"
};
var _default = BAMViewer;
exports["default"] = _default;